import React, { useState } from "react";
import { FaUser } from "react-icons/fa";
import { BsCartFill } from "react-icons/bs";
import { FaUserCircle } from "react-icons/fa";
import { IoLogOutOutline } from "react-icons/io5";
import { FiMenu } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../Redux/Actions/userAction";

const Header = ({ sidebarCall }) => {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [toggleProfile, setToggleProfile] = useState(false);

  function toggleProfileIcon() {
    setToggleProfile(!toggleProfile);
  }

  async function handleLogout() {
    // logout User
    dispatch(logoutUser());
    navigate("/");
  }

  return (
    <>
      <div className="w-full  px-4 py-2 lg:py-4  bg-rose-600 ">
        <div className="flex items-center justify-around mb-2 lg:mb-0">
          <div className="w-8">
            <button onClick={sidebarCall} className=" cursor-pointer">
              <FiMenu
                fontSize={"30px"}
                color="white"
                className="cursor-pointer"
              />
            </button>
          </div>
          <div className="flex-grow lg:flex-none">
            <Link to="/home">
              <h2 className="text-2xl cursor-pointer text-center font-semibold md:font-bold text-neutral-50">
                Apna App{" "}
              </h2>
            </Link>
          </div>

          <div className=" hidden lg:block relative basis-1/2  md:mr-0 ">
            <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
              <svg
                className="w-5 h-5 text-gray-500"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </div>
            <input
              type="text"
              id="email-adress-icon"
              className=" focus:outline-none border-b-2 block  h-10 pl-10 w-full text-gray-700 md:bg-gray-100 rounded-md  border-gray-200 sm:text-sm focus:bg-white focus:ring-red-500 focus:border-white-500 "
              placeholder="Search for products,brands & more"
            />
          </div>

          {!user ? (
            <Link
              to="/login"
              className="flex flex-row items-center cursor-pointer px-1 lg:px-0"
            >
              <FaUser className="text-xl text-white" />
              <span className="hidden lg:block font-medium ml-2 text-neutral-50 ">
                Sign in / Sign up
              </span>
            </Link>
          ) : (
            <div
              onClick={toggleProfileIcon}
              className="relative flex flex-row items-center cursor-pointer px-1 lg:px-0"
            >
              <FaUser className="text-xl text-white" />
              <span className="hidden lg:block font-medium ml-2 text-neutral-50 ">
                Profile
              </span>
              <>
                <div
                  className={`${
                    toggleProfile ? "absolute" : "hidden"
                  } -right-10 top-7 mt-2 w-40 bg-codewar border border-blue-900 border-opacity-80 bg-red-700 divide-y divide-blue-900 rounded-md overflow-hidden shadow-xl z-20`}
                >
                  <Link
                    to={`/profile`}
                    className="flex items-center capitalize gap-2 px-4 py-2 text-md text-white hover:bg-codewar_hoverdivbutton"
                  >
                    <FaUserCircle className="text-slate-10 text-lg" />
                    profile
                  </Link>

                  <button
                    onClick={handleLogout}
                    className="flex items-center w-full capitalize gap-2 px-4 py-2 text-md text-white hover:bg-codewar_hoverdivbutton"
                  >
                    <IoLogOutOutline className="text-slate-10 text-lg" />
                    logout
                  </button>
                </div>
              </>
            </div>
          )}

          <Link to="/cart">
            <div className="flex flex-row items-center cursor-pointer px-1 lg:px-0">
              <BsCartFill className="text-xl text-white" />
              <span className="hidden lg:block font-medium ml-2 text-neutral-50">
                Cart
              </span>
            </div>
          </Link>
        </div>

        <div className=" block lg:hidden relative  xl:basis-large  md:mr-0 md:block">
          <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
            <svg
              className="w-5 h-5 text-gray-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </div>
          <input
            type="text"
            id="email-adress-icon"
            className=" focus:outline-none border-b-2 block  h-10 pl-10 w-full text-gray-700 md:bg-gray-100 rounded-md  border-gray-200 sm:text-sm focus:bg-white focus:ring-red-500 focus:border-white-500 "
            placeholder="Search for products,brands & more"
          />
        </div>
      </div>
    </>
  );
};

export default Header;
